.svs-carousel-wrapper .svs-carousel {
  display: flex;
  flex-flow: row nowrap;
  position: relative; // must be relative to measure offsiteLeft properly
  gap: 8px;
  padding: 0 4em 0 var(--list-item-large-padding-horizontal, 16px);

  &-container {
    overflow-x: auto;
    width: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    padding-top: 8px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  & > * {
    white-space: nowrap;
  }

  &-nav {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;
    padding: 0 var(--list-item-large-padding-horizontal, 16px);

    &__spacer {
      flex-grow: 1;
    }
  }

  &__dummy {
    width: 100px;
    max-width: 100px;
    height: 1px;
  }
}
